import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import PageSEO from '../Common/PageSEO';
import {
    FeatureHero,
    FeatureCtaButton,
    FeatureSection,
    FeatureCta
} from '../Common/FeatureContent';
import { useLocale } from '../../localization/LocaleContext';
import { ROUTE_PATHS } from '../../localization/constants';
import './resourcePages.css';

const SUPPORT_EMAIL = 'support@invoicepoint.app';

function ContactMain(){
    const { t, toLocalizedPath, locale } = useLocale();
    const p = (key) => t(`resourcePages.contact.${key}`);

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) {
        return <Loader/>;
    }

    return(
        <Fragment>
            <PageSEO title={p('metaTitle')} description={p('metaDescription')} path={ROUTE_PATHS.contact} locale={locale} />

            <FeatureHero
                eyebrow={p('eyebrow')}
                title={p('heroTitle')}
                highlight={p('heroHighlight')}
                subtitle={p('heroSubtitle')}
                cta={<FeatureCtaButton href={`mailto:${SUPPORT_EMAIL}`}>{p('heroCta')}</FeatureCtaButton>}
            />

            <FeatureSection alt title={p('channelsSectionTitle')}>
                <div className="rp-card-grid rp-card-grid-3">
                    <div className="rp-card">
                        <h3 className="rp-card-title">{p('emailCardTitle')}</h3>
                        <p className="rp-card-description">{p('emailCardDescription')}</p>
                        <a className="rp-card-link" href={`mailto:${SUPPORT_EMAIL}`}>{p('emailCta')}</a>
                    </div>
                    <div className="rp-card">
                        <h3 className="rp-card-title">{p('helpCenterCardTitle')}</h3>
                        <p className="rp-card-description">{p('helpCenterCardDescription')}</p>
                        <Link className="rp-card-link" to={toLocalizedPath('helpCenter')}>{p('helpCenterCta')}</Link>
                    </div>
                    <div className="rp-card">
                        <h3 className="rp-card-title">{p('faqsCardTitle')}</h3>
                        <p className="rp-card-description">{p('faqsCardDescription')}</p>
                        <Link className="rp-card-link" to={toLocalizedPath('faqs')}>{p('faqsCta')}</Link>
                    </div>
                </div>
            </FeatureSection>

            {/* <FeatureSection title={p('addressSectionTitle')}>
                <div className="rp-address-block">
                    <p className="rp-address-name">{p('addressLine1')}</p>
                    <p className="rp-address-line">{p('addressLine2')}</p>
                    <p className="rp-address-line">
                        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    </p>
                </div>
            </FeatureSection> */}

            <FeatureCta
                title={p('ctaTitle')}
                description={p('ctaDescription')}
                ctaHref={`mailto:${SUPPORT_EMAIL}`}
                ctaLabel={p('ctaButton')}
            />

            <Footer/>
        </Fragment>
    );
}

export default ContactMain;
